import { Avatar, Box, Paper } from '@mui/material'
import { FC } from 'react'

type Props = {
  isIncoming: boolean
  avatarSrc: string
  text: string
}

const Message: FC<Props> = ({ isIncoming, avatarSrc, text }) => {
  return (
    <Box
      display='flex'
      gap='10px'
      flexDirection={isIncoming ? 'row' : 'row-reverse'}
      justifyContent='flex-start'
      alignItems='flex-end'
      sx={{
        '@media (max-width: 768px)': {
          gap: '8px'
        },
        '@media (max-width: 480px)': {
          gap: '6px'
        }
      }}>
      <Avatar
        src={avatarSrc}
        sx={{
          mb: '2px',
          width: '36px',
          height: '36px',
          '@media (max-width: 1280px)': {
            mb: 0
          },
          '@media (max-width: 480px)': {
            width: '28px',
            height: '28px'
          }
        }}
      />
      <Paper
        elevation={0}
        sx={{
          padding: '14px',
          borderRadius: '15px',
          backgroundColor: isIncoming ? 'var(--eta)' : 'var(--alpha)',
          color: isIncoming ? 'var(--alpha)' : 'var(--omega)',
          maxWidth: isIncoming ? 235 : 213,
          fontFamily: `'__golosTextVF_099e87', '__golosTextVF_Fallback_099e87', sans-serif`,
          fontWeight: 400,
          lineHeight: '120%',
          fontSize: '11px',
          '@media (max-width: 1280px)': {
            fontSize: '10px',
            padding: '11px',
            maxWidth: isIncoming ? 212 : 191
          },
          '@media (max-width: 768px)': {
            fontSize: '8px',
            padding: '12px',
            maxWidth: isIncoming ? 171 : 169
          },
          '@media (max-width: 480px)': {
            fontSize: '8px',
            padding: '11px',
            borderRadius: '11px',
            maxWidth: isIncoming ? 178 : 163
          }
        }}>
        {text}
      </Paper>
    </Box>
  )
}

export default Message
